// GWFForm.jsx
import { useState } from "react"
import "../../css/DemoCode.css"

/**
 * Groundwater Form is a group of data inputs usually shown when clicking on Subcatchment->Groundwater. 
 * This form is contained within GroundwaterDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function GWFForm({model, setModel, target}) {
  const [lateral, setLateral] = useState(model.GWF[target].LATERAL)
  const [deep, setDeep]       = useState(model.GWF[target].DEEP)

  const updateValue = (val, type) => {
    if(model && model.GWF){
      setModel(prev => ({
        ...prev,
        GWF:{
          ...prev.GWF,
          [target]: {
            ...prev.GWF[target],
            [type]: val
          }
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            target && 
            target.length > 0 && 
            <>
            <label className='editor-small' >Lateral
              <textarea 
                      style={{width: '95%', display: 'flex', height: '150px'}}
                      onChange={(e)=>{setLateral(e.target.value); updateValue(e.target.value, 'LATERAL')}}
                      value={lateral}
                      id={'lateral'+target}
              />
            </label>
            <label className='editor-small' >Deep
              <textarea 
                      style={{width: '95%', display: 'flex', height: '150px'}}
                      onChange={(e)=>{setDeep(e.target.value); updateValue(e.target.value, 'DEEP')}}
                      value={deep}
                      id={'deep'+target}
              />
            </label>
            </>
          )}
        </>
      }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}